import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import moment from 'moment';
import { isPrepaid, visitLabel } from '@/utils/kidSchool';
let KidSchoolKidCard = class KidSchoolKidCard extends Vue {
    //<editor-fold desc="Props">
    kid;
    /** The child's notes, newest first. */
    notes;
    /** The kid school on screen; a note from another one is read-only here. */
    lessonId;
    /** The backoffice employee reading the card, who may rewrite their own notes. */
    employeeId;
    /** A moderator or admin, who corrects and removes anyone's note. */
    canManageNotes;
    canWrite;
    writing;
    /** Another kid's arrival is being written, so this one waits its turn. */
    locked;
    savingNote;
    error;
    //</editor-fold>
    /** The note being written: null when none, empty string for a new one. */
    editingNoteId = null;
    draft = '';
    /** The card opens closed: a parent reads over the shoulder at the lift. */
    expanded = false;
    //<editor-fold desc="Methods">
    startNote(note) {
        this.editingNoteId = note ? note.id : '';
        this.draft = note ? note.content : '';
    }
    cancelNote() {
        this.editingNoteId = null;
    }
    saveNote() {
        const noteId = this.editingNoteId || undefined;
        this.editingNoteId = null;
        this.$emit('saveNote', { content: this.draft.trim(), noteId });
    }
    canManageNote(note) {
        if (note.pending) {
            return false;
        }
        if (this.canManageNotes) {
            return true;
        }
        return this.canWrite && note.authorId === this.employeeId && note.lessonId === this.lessonId;
    }
    noteLabel(note) {
        const date = moment(note.createdAt).format('D. M.');
        return note.authorName ? `${date} - ${note.authorName}` : date;
    }
    //</editor-fold>
    //<editor-fold desc="Getters">
    get noteCount() {
        return this.notes.length + (this.kid.note ? 1 : 0);
    }
    get ageLabel() {
        if (this.kid.age === 1) {
            return '1 rok';
        }
        return this.kid.age < 5 ? `${this.kid.age} roky` : `${this.kid.age} let`;
    }
    get visitsLabel() {
        const label = visitLabel(this.kid.visitsCount);
        return this.kid.lastAttendedAt
            ? `${label} · naposledy ${moment(this.kid.lastAttendedAt).format('D. M.')}`
            : label;
    }
    get paymentLabel() {
        if (!this.kid.isPaid) {
            return 'Nezaplaceno';
        }
        return isPrepaid(this.kid.paymentMethod) ? 'Zaplaceno předem' : 'Zaplaceno';
    }
};
__decorate([
    Prop({ required: true })
], KidSchoolKidCard.prototype, "kid", void 0);
__decorate([
    Prop({ default: () => [] })
], KidSchoolKidCard.prototype, "notes", void 0);
__decorate([
    Prop({ required: true })
], KidSchoolKidCard.prototype, "lessonId", void 0);
__decorate([
    Prop({ default: '' })
], KidSchoolKidCard.prototype, "employeeId", void 0);
__decorate([
    Prop({ default: false })
], KidSchoolKidCard.prototype, "canManageNotes", void 0);
__decorate([
    Prop({ default: false })
], KidSchoolKidCard.prototype, "canWrite", void 0);
__decorate([
    Prop({ default: false })
], KidSchoolKidCard.prototype, "writing", void 0);
__decorate([
    Prop({ default: false })
], KidSchoolKidCard.prototype, "locked", void 0);
__decorate([
    Prop({ default: false })
], KidSchoolKidCard.prototype, "savingNote", void 0);
__decorate([
    Prop({ default: '' })
], KidSchoolKidCard.prototype, "error", void 0);
KidSchoolKidCard = __decorate([
    Component
], KidSchoolKidCard);
export default KidSchoolKidCard;
